/**
 * For legibility's sake, all references/docs are at the bottom of the file
 *
 * For help with "define all spots, call display once,
 * see https://developers.google.com/publisher-tag/guides/ad-best-practices#use_single_request_architecture_correctly
 *
 * 2024-09-19 : 2 ad spots aren't currently used : the index ones
 *              Currently only showing on profs home and profs single post ( top + sidebar )
 *
 */
import debounce from 'lodash-es/debounce';

export default class Ads
{
    constructor ()
    {


        this.desktopSizeMinWidth      = 768;
        this.currentMobileDesktopMode = this.detectMobileDesktopMode();


        this.pageType = document.body.dataset.pageName;

        // home - profs
        this.homeProfsTopAdSlot    = document.querySelector( '.home-profs-top-ad-slot' );
        this.hasHomeProfsTopAdSlot = this.homeProfsTopAdSlot !== null;
        this.homeProfsTopAdId      = 'div-gpt-ad-1726598237759-0';

        this.homeProfsSidebarAdSlots       = document.querySelectorAll( '.home-profs-sidebar-ad-slot' );
        this.hasHomeProfsSidebarAdSlots    = this.homeProfsSidebarAdSlots !== null && this.homeProfsSidebarAdSlots.length > 0;
        this.homeProfsSidebarAdSlotDesktop = this.hasHomeProfsSidebarAdSlots
            ? Array.from( this.homeProfsSidebarAdSlots ).find( el => el.classList.contains( 'desktop-slot' ) )
            : null;
        this.homeProfsSidebarAdSlotMobile  = this.hasHomeProfsSidebarAdSlots
            ? Array.from( this.homeProfsSidebarAdSlots ).find( el => el.classList.contains( 'mobile-slot' ) )
            : null;
        this.homeProfsSidebarAdId          = 'div-gpt-ad-1726598316803-0';


        // single - profs
        this.singlePostProfsTopAdSlot    = document.querySelector( '.single-post-profs-top-ad-slot' );
        this.hasSinglePostProfsTopAdSlot = this.singlePostProfsTopAdSlot !== null;
        this.singlePostProfsTopAdId      = 'div-gpt-ad-1726599924636-0';

        this.singlePostProfsSidebarAdSlots       = document.querySelectorAll( '.single-post-profs-sidebar-ad-slot' );
        this.hasSinglePostProfsSidebarAdSlots    = this.singlePostProfsSidebarAdSlots !== null && this.singlePostProfsSidebarAdSlots.length > 0;
        this.singlePostProfsSidebarAdSlotDesktop = this.singlePostProfsSidebarAdSlots
            ? Array.from( this.singlePostProfsSidebarAdSlots ).find( el => el.classList.contains( 'desktop-slot' ) )
            : null;
        this.singlePostProfsSidebarAdSlotMobile  = this.singlePostProfsSidebarAdSlots
            ? Array.from( this.singlePostProfsSidebarAdSlots ).find( el => el.classList.contains( 'mobile-slot' ) )
            : null;

        this.singlePostProfsSidebarAdId = 'div-gpt-ad-1726599967952-0';


        if (
            !this.hasHomeProfsTopAdSlot
            && !this.hasHomeProfsSidebarAdSlots
            && !this.hasSinglePostProfsTopAdSlot
            && !this.hasSinglePostProfsSidebarAdSlots
        )
        {
            console.info( '[Ads] No ads to show. Bailing.' )
            return;
        }


        this.allSlots        = [];
        this.allCreatedSlots = [];

        console.log( {
                homeProfsTopAdSlot            : this.homeProfsTopAdSlot,
                hasHomeProfsTopAdSlot         : this.hasHomeProfsTopAdSlot,
                hasHomeProfsSidebarAdSlots    : this.hasHomeProfsSidebarAdSlots,
                homeProfsSidebarAdSlotDesktop : this.homeProfsSidebarAdSlotDesktop,
                homeProfsSidebarAdSlotMobile  : this.homeProfsSidebarAdSlotMobile,
                // single - profs
                singlePostProfsTopAdSlot            : this.singlePostProfsTopAdSlot,
                hasSinglePostProfsTopAdSlot         : this.hasSinglePostProfsTopAdSlot,
                singlePostProfsSidebarAdSlots       : this.singlePostProfsSidebarAdSlots,
                hasSinglePostProfsSidebarAdSlots    : this.hasSinglePostProfsSidebarAdSlots,
                singlePostProfsSidebarAdSlotDesktop : this.singlePostProfsSidebarAdSlotDesktop,
                singlePostProfsSidebarAdSlotMobile  : this.singlePostProfsSidebarAdSlotMobile,
            },
        )


        // this.injectMainScript();

        window.googletag = window.googletag || { cmd : [] };
        googletag.cmd.push( () =>
        {
            // Disable initial load, to precisely control when ads are requested.
            googletag.pubads().disableInitialLoad();
            googletag.pubads().enableSingleRequest();
        } );

        this.addAndDefineSlots();
        this.activateAds();


        const debouncedResize = debounce( () =>
        {
            this.handleResize( this );
        }, 500 )
        window.addEventListener( 'resize', () =>
        {
            debouncedResize();
        } );
    }


    addAndDefineSlots ()
    {

        // home profs
        if ( this.hasHomeProfsTopAdSlot )
        {
            this.defineHomeProfsTopAdSlot();
        }

        if ( this.hasHomeProfsSidebarAdSlots )
        {
            this.defineHomeProfsSidebarAdSlot( this.currentMobileDesktopMode );
        }


        // single profs
        if ( this.hasSinglePostProfsTopAdSlot )
        {
            this.defineSinglePostProfsTopAdSlot();
        }

        if ( this.hasSinglePostProfsSidebarAdSlots )
        {
            this.defineSinglePostProfsSidebarAdSlot( this.currentMobileDesktopMode );
        }
    }

    defineHomeProfsTopAdSlot ()
    {
        this.addSlot(
            this.homeProfsTopAdSlot,
            this.homeProfsTopAdId,
            300,
            250,
        );

        this.allSlots.push( this.homeProfsTopAdId );

        googletag.cmd.push( () =>
        {
            this.topAdSlot = googletag
                .defineSlot( '/21617447563/asdelinfo/asHomeHeader', [ [ 970, 250 ], [ 300, 250 ] ], this.homeProfsTopAdId )
                .setCollapseEmptyDiv( true, true )
                .addService( googletag.pubads() )


            // https://developers.google.com/publisher-tag/guides/ad-sizes#responsive_ads
            const responsiveMapping = googletag
                .sizeMapping()
                .addSize(
                    [ 1024, 768 ],
                    [
                        [ 970, 250 ],
                    ],
                )
                .addSize( [ 300, 300 ], [ [ 300, 250 ] ] )
                .build();

            this.topAdSlot.defineSizeMapping( responsiveMapping );
        } );

        console.info( '[Ads:defineHomeProfsTopAdSlot] ' + this.homeProfsTopAdId + ' added' );
    }

    displayTopSlot ()
    {
        googletag.cmd.push( () =>
        {
            googletag.pubads().refresh( [ this.topAdSlot ] );
            googletag.display( this.topAdSlot );
            googletag.pubads().collapseEmptyDivs();
            console.log( '[Ads:displayTopSlot]', this.topAdSlot )
        } );
    }

    defineHomeProfsSidebarAdSlot ( mobileOrDesktop )
    {

        const wantedParentSlot = mobileOrDesktop === 'mobile' ? this.homeProfsSidebarAdSlotMobile : this.homeProfsSidebarAdSlotDesktop;

        this.addSlot(
            wantedParentSlot,
            this.homeProfsSidebarAdId,
            300,
            600,
        );

        this.allSlots.push( this.homeProfsSidebarAdId );

        googletag.cmd.push( () =>
        {
            this.sidebarAdSlot = googletag
                .defineSlot( '/21617447563/asdelinfo/asHomeRail', [ 300, 600 ], this.homeProfsSidebarAdId )
                .setCollapseEmptyDiv( true, true )
                .addService( googletag.pubads() )

        } );
        console.info( '[Ads:defineHomeProfsSidebarAdSlot] ' + this.homeProfsSidebarAdId + ' added. Parent: ', wantedParentSlot );
    }

    displaySidebarSlot ()
    {
        googletag.cmd.push( () =>
        {
            googletag.pubads().refresh( [ this.sidebarAdSlot ] );
            googletag.display( this.sidebarAdSlot );

            googletag.pubads().collapseEmptyDivs();
        } );
        console.log( '[Ads:displaySidebarSlot]', this.sidebarAdSlot )
    }

    destroyProfsSidebarSlot ()
    {

        const whichId = this.pageType === 'accueil-profs' ? this.homeProfsSidebarAdId : this.singlePostProfsSidebarAdId;

        if ( this.sidebarAdSlot )
        {
            // https://developers.google.com/publisher-tag/reference#googletag.destroySlots
            console.info( '[Ads:destroyProfsSidebarSlot] Going to destroy', this.sidebarAdSlot )
            googletag.destroySlots( [ this.sidebarAdSlot ] );
        }

        const existingSlot = document.querySelector( '#' + whichId );
        if ( existingSlot )
        {
            existingSlot.remove();
        }
    }

    defineSinglePostProfsTopAdSlot ()
    {
        this.addSlot(
            this.singlePostProfsTopAdSlot,
            this.singlePostProfsTopAdId,
            300,
            250,
        );

        this.allSlots.push( this.singlePostProfsTopAdId );

        googletag.cmd.push( () =>
        {
            this.topAdSlot = googletag
                .defineSlot( '/21617447563/asdelinfo/asArticleHeader', [ [ 970, 250 ], [ 300, 250 ] ], this.singlePostProfsTopAdId )
                .setCollapseEmptyDiv( true, true )
                .addService( googletag.pubads() )


            // https://developers.google.com/publisher-tag/guides/ad-sizes#responsive_ads
            const responsiveMapping = googletag
                .sizeMapping()
                .addSize(
                    [ 1024, 768 ],
                    [
                        [ 970, 250 ],
                    ],
                )
                .addSize( [ 300, 300 ], [ [ 300, 250 ] ] )
                .build();

            this.topAdSlot.defineSizeMapping( responsiveMapping );
        } );

        console.info( '[Ads:defineSinglePostProfsTopAdSlot] ' + this.singlePostProfsTopAdId + ' added' );
    }

    defineSinglePostProfsSidebarAdSlot ( mobileOrDesktop )
    {

        const wantedParentSlot = mobileOrDesktop === 'mobile' ? this.singlePostProfsSidebarAdSlotMobile : this.singlePostProfsSidebarAdSlotDesktop;


        this.addSlot(
            wantedParentSlot,
            this.singlePostProfsSidebarAdId,
            300,
            600,
        );

        this.allSlots.push( this.singlePostProfsSidebarAdId );


        googletag.cmd.push( () =>
        {
            this.sidebarAdSlot = googletag
                .defineSlot( '/21617447563/asdelinfo/asArticleRail', [ 300, 600 ], this.singlePostProfsSidebarAdId )
                .setCollapseEmptyDiv( true, true )
                .addService( googletag.pubads() )

        } );

        console.info( '[Ads:defineSinglePostProfsSidebarAdSlot] ' + this.singlePostProfsSidebarAdId + ' added. Parent: ', wantedParentSlot );
    }


    activateAds ()
    {

        googletag.cmd.push( () =>
        {


            // googletag.pubads().collapseEmptyDivs();
            googletag.enableServices();

            // we only need to call display on one of them
            // and the other will also be displayed

            console.info( '[Ads:activateAds] All ads have been defined. Going to display them ', this.allSlots )

            // googletag.pubads().refresh( this.allSlots );
            googletag.pubads().refresh( [ this.topAdSlot, this.sidebarAdSlot ] );
            googletag.display( this.topAdSlot );
            googletag.display( this.sidebarAdSlot );

            googletag.pubads().collapseEmptyDivs();
            // this.allSlots.forEach( slot => googletag.display( slot ) );
        } );

    }

    addSlot ( parentSlot, id, minWidth, minHeight )
    {

        const adInnerSlot           = document.createElement( 'div' );
        adInnerSlot.id              = id;
        adInnerSlot.style.minWidth  = minWidth + 'px';
        adInnerSlot.style.minHeight = minHeight + 'px';

        parentSlot.appendChild( adInnerSlot );

    }


    detectMobileDesktopMode ()
    {
        return window.innerWidth >= this.desktopSizeMinWidth ? 'desktop' : 'mobile';
    }

    handleResize ()
    {

        console.log( 'handleResize' )
        const currMobileDesktopMode = this.detectMobileDesktopMode();
        if ( currMobileDesktopMode === this.currentMobileDesktopMode )
        {
            // unless we're going from mobile to desktop or vice versa, we don't care
            return;
        }

        console.log( '[Ads] size switch. New mode = ' + currMobileDesktopMode );
        this.currentMobileDesktopMode = currMobileDesktopMode;

        // setup mobile ads
        this.destroyProfsSidebarSlot();
        if ( this.pageType === 'accueil-profs' )
        {

            this.defineHomeProfsSidebarAdSlot( currMobileDesktopMode );
        } else
        {

            this.defineSinglePostProfsSidebarAdSlot( currMobileDesktopMode );
        }
        this.displaySidebarSlot();
        googletag.pubads().collapseEmptyDivs();
    }
}


/**
 * Home top row
 * Dans <head>
 *
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * <script>
 *
 *   window.googletag = window.googletag || {cmd: []};
 *
 *   googletag.cmd.push(function() {
 *
 *     googletag.defineSlot('/21617447563/asdelinfo/asHomeHeader', [[970, 250], [300, 250]], 'div-gpt-ad-1726598237759-0').addService(googletag.pubads());
 *
 *     googletag.pubads().enableSingleRequest();
 *
 *     googletag.pubads().collapseEmptyDivs();
 *
 *     googletag.enableServices();
 *
 *   });
 *
 * </script>
 *
 * À l’emplacement dans <body>
 *
 * <!-- /21617447563/asdelinfo/asHomeHeader -->
 *
 * <div id='div-gpt-ad-1726598237759-0' style='min-width: 300px; min-height: 250px;'>
 *
 *   <script>
 *
 *     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726598237759-0'); });
 *
 *   </script>
 *
 * </div>
 *
 *
 *
 *
 *
 *
 * Home sidebar
 *
 * Dans <head>
 *
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * <script>
 *
 *   window.googletag = window.googletag || {cmd: []};
 *
 *   googletag.cmd.push(function() {
 *
 *     googletag.defineSlot('/21617447563/asdelinfo/asHomeRail', [300, 600], 'div-gpt-ad-1726598316803-0').addService(googletag.pubads());
 *
 *     googletag.pubads().enableSingleRequest();
 *
 *     googletag.pubads().collapseEmptyDivs();
 *
 *     googletag.enableServices();
 *
 *   });
 *
 * </script>
 *
 * À l’emplacement dans <body>
 *
 * <!-- /21617447563/asdelinfo/asHomeRail -->
 *
 * <div id='div-gpt-ad-1726598316803-0' style='min-width: 300px; min-height: 600px;'>
 *
 *   <script>
 *
 *     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726598316803-0'); });
 *
 *   </script>
 *
 * </div>
 *
 *
 *
 *
 * Index - top
 * Dans <head>
 *
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * <script>
 *
 *   window.googletag = window.googletag || {cmd: []};
 *
 *   googletag.cmd.push(function() {
 *
 *     googletag.defineSlot('/21617447563/asdelinfo/asAllHeader', [[970, 250], [300, 250]], 'div-gpt-ad-1726599105139-0').addService(googletag.pubads());
 *
 *     googletag.pubads().enableSingleRequest();
 *
 *     googletag.pubads().collapseEmptyDivs();
 *
 *     googletag.enableServices();
 *
 *   });
 *
 * </script>
 *
 * À l’emplacement dans <body>
 *
 * <!-- /21617447563/asdelinfo/asAllHeader -->
 *
 * <div id='div-gpt-ad-1726599105139-0' style='min-width: 300px; min-height: 250px;'>
 *
 *   <script>
 *
 *     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726599105139-0'); });
 *
 *   </script>
 *
 * </div>
 *
 *
 *
 *
 *
 * Index - sidebar
 *
 * Dans <head>
 *
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * <script>
 *
 *   window.googletag = window.googletag || {cmd: []};
 *
 *   googletag.cmd.push(function() {
 *
 *     googletag.defineSlot('/21617447563/asdelinfo/asAllRail', [300, 600], 'div-gpt-ad-1726599204783-0').addService(googletag.pubads());
 *
 *     googletag.pubads().enableSingleRequest();
 *
 *     googletag.pubads().collapseEmptyDivs();
 *
 *     googletag.enableServices();
 *
 *   });
 *
 * </script>
 *
 * À l’emplacement dans <body>
 *
 * <!-- /21617447563/asdelinfo/asAllRail -->
 *
 * <div id='div-gpt-ad-1726599204783-0' style='min-width: 300px; min-height: 600px;'>
 *
 *   <script>
 *
 *     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726599204783-0'); });
 *
 *   </script>
 *
 * </div>
 *
 *
 *
 *
 *
 *
 *
 * Single - head
 *
 * Dans <head>
 *
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * <script>
 *
 *   window.googletag = window.googletag || {cmd: []};
 *
 *   googletag.cmd.push(function() {
 *
 *     googletag.defineSlot('/21617447563/asdelinfo/asArticleHeader', [[970, 250], [300, 250]], 'div-gpt-ad-1726599924636-0').addService(googletag.pubads());
 *
 *     googletag.pubads().enableSingleRequest();
 *
 *     googletag.pubads().collapseEmptyDivs();
 *
 *     googletag.enableServices();
 *
 *   });
 *
 * </script>
 *
 * À l’emplacement dans <body>
 *
 * <!-- /21617447563/asdelinfo/asArticleHeader -->
 *
 * <div id='div-gpt-ad-1726599924636-0' style='min-width: 300px; min-height: 250px;'>
 *
 *   <script>
 *
 *     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726599924636-0'); });
 *
 *   </script>
 *
 * </div>
 *
 *
 *
 *
 *
 *
 * Single sidebar
 * Dans <head>
 *
 * <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
 *
 * <script>
 *
 *   window.googletag = window.googletag || {cmd: []};
 *
 *   googletag.cmd.push(function() {
 *
 *     googletag.defineSlot('/21617447563/asdelinfo/asArticleRail', [300, 600], 'div-gpt-ad-1726599967952-0').addService(googletag.pubads());
 *
 *     googletag.pubads().enableSingleRequest();
 *
 *     googletag.pubads().collapseEmptyDivs();
 *
 *     googletag.enableServices();
 *
 *   });
 *
 * </script>
 *
 * À l’emplacement dans <body>
 *
 * <!-- /21617447563/asdelinfo/asArticleRail -->
 *
 * <div id='div-gpt-ad-1726599967952-0' style='min-width: 300px; min-height: 600px;'>
 *
 *   <script>
 *
 *     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1726599967952-0'); });
 *
 *   </script>
 *
 * </div>
 *
 */
